import React, { useEffect, useState } from 'react';

export default function ReadingProgress() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const el = document.documentElement;
      const max = el.scrollHeight - el.clientHeight;
      setPct(max > 0 ? Math.min(100, (el.scrollTop / max) * 100) : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); };
  }, []);
  return (
    <div className="fixed top-0 left-0 right-0 h-[3px] z-[55] pointer-events-none" data-testid="reading-progress">
      <div className="h-full bg-[#D01919] origin-left" style={{ transform: `scaleX(${pct / 100})`, transition: 'transform 80ms linear' }} data-testid="reading-progress-bar" data-progress={Math.round(pct)} />
    </div>
  );
}
